// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".legend-section[data-v-59c2fb64]{background-color:#fff}.row .col[data-v-59c2fb64]{padding:8px}.row .col[data-v-59c2fb64]:nth-child(3){display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-pack:end;-ms-flex-pack:end;justify-content:flex-end}", ""]);
// Exports
module.exports = exports;
